const ready = require("%helpers%/document-ready.js");

ready(function() {

	const $headerScroll = $(".header-scroll");
	const $blockFilter = $(".results");

	// -- Functions BEGIN
	const checkOffset = () => {
		const offsetBlockFilter = $blockFilter.offset().top;
		
		document.addEventListener("scroll", function () {
			const curOffset = $(this).scrollTop();

			if ( curOffset >= offsetBlockFilter ) {
				$headerScroll.addClass("header-scroll_visible");
			} else {
				$headerScroll.removeClass("header-scroll_visible");
			}
		}, {passive: true});
	};
	// -- Functions END

	if ( $headerScroll.length && $blockFilter.length ) checkOffset();

});

